import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { RequestItem } from "src/app/corporate/core/model/request-item";
import { Condition } from "src/app/corporate/core/model/condition";
import { RequestItemService } from "src/app/corporate/core/service/request-item.service";
import { ConditionService } from "src/app/corporate/core/service/condition.service";

@Component({
  selector: "app-form-add-condition",
  templateUrl: "./form-add-condition.component.html",
  styleUrls: ["./form-add-condition.component.scss"],
})
export class FormAddConditionComponent implements OnInit {
  @Input() requestItemId;
  requestId: number;

  requestItem: RequestItem;
  condition: Condition = new Condition();

  form2: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _requestItemService: RequestItemService,
    private _conditionService: ConditionService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      libelle: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getRequestItemById(this.requestItemId);
  }

  getRequestItemById(requestItemId) {
    this._requestItemService.getRequestItemById(requestItemId).subscribe(
      (data) => {
        this.requestItem = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.spinner.show();
    const dateTime = new Date().getTime();

    this.condition.requestItem = this.requestItem;
    this.condition.code = "condition_" + dateTime;
    this.condition.checked = true;

    this._conditionService
      .postCondition(this.condition)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
